import { render } from "./LogisticsWaybillView.vue?vue&type=template&id=6b23fec7&scoped=true"
import script from "./LogisticsWaybillView.vue?vue&type=script&lang=js"
export * from "./LogisticsWaybillView.vue?vue&type=script&lang=js"

import "./LogisticsWaybillView.vue?vue&type=style&index=0&id=6b23fec7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b23fec7"]])

export default __exports__